/** Pure, shared by the browser and Edge Functions. No secrets or server imports. */
export type CustomerLocale = 'en' | 'pt-BR';
export const normalizeLocale = (value: unknown): CustomerLocale => value === 'pt-BR' ? 'pt-BR' : 'en';
// Each language is its own site at the same paths: gizmodata.com (English), gizmodata.com.br (Portuguese).
export const siteUrl = (path: string, locale: CustomerLocale) => `${locale === 'pt-BR' ? 'https://gizmodata.com.br' : 'https://gizmodata.com'}${path}`;

export const smsDisclosure = {
  en: {
    checkbox: 'Yes, I would like to receive automated text messages from GizmoData about product releases, promotional offers, and important updates. I understand I will receive up to 4 messages per month.',
    frequencyLabel: 'Message Frequency:',
    frequency: 'You will receive up to 4 messages per month.',
    ratesLabel: 'Standard Rates:',
    rates: 'Message and data rates may apply depending on your mobile phone service plan.',
    helpLabel: 'Help & Stop:',
    help: 'Reply HELP for help or STOP to cancel any time. By providing your phone number and checking the box, you agree to receive text messages from GizmoData. Consent is not required to make a purchase.',
  },
  'pt-BR': {
    checkbox: 'Sim, quero receber mensagens de texto automáticas da GizmoData sobre lançamentos de produtos, ofertas promocionais e atualizações importantes. Entendo que receberei até 4 mensagens por mês.',
    frequencyLabel: 'Frequência das mensagens:',
    frequency: 'Você receberá até 4 mensagens por mês.',
    ratesLabel: 'Tarifas da operadora:',
    rates: 'Podem ser cobradas tarifas de mensagens e dados, conforme seu plano de telefonia móvel.',
    helpLabel: 'Ajuda e cancelamento:',
    help: 'Responda HELP para obter ajuda ou STOP para cancelar a qualquer momento. Ao informar seu número de telefone e marcar a opção, você concorda em receber mensagens de texto da GizmoData. Essa autorização não é necessária para realizar uma compra.',
  },
} satisfies Record<CustomerLocale, Record<string, string>>;

export function consentText(locale: CustomerLocale): string {
  const d = smsDisclosure[locale];
  return [d.checkbox, d.frequencyLabel, d.frequency, d.ratesLabel, d.rates, d.helpLabel, d.help].join(' ');
}

export function errorCode(message: string): string {
  if (/verification|human/i.test(message)) return 'verification_failed';
  if (/phone|mobile/i.test(message)) return 'invalid_phone';
  if (/required|invalid|must|minimum|accepted|between|too long/i.test(message)) return 'validation_error';
  return 'unexpected_error';
}
